import React from 'react'
import {PropTypes} from 'prop-types'

import auth from './Auth';
import types from '../../types/types';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

// A button "edit" with control if user has  root or admin credential.
// ...props is used for Button component. Eg. to parse an "id" or other parameters
export const ButtonEdit = ({to = "", icon, onClick = "", linkClass = "", buttonClass = "", ...props}, context) => {

    // Get user from storage
    const userLogged = auth.getSessionUser();  // TODO to remove after old code that use old autentication
    
    const buttonClassName = (buttonClass)?"snx-btn-action " +  buttonClass:"snx-btn-action";
    const editIcon = (icon)?icon:"edit";

    const isRootOrAdmin = userLogged.roles[0].id === types.USER_ROOT_ID || userLogged.roles[0].id === types.USER_ADMIN_ID;

    return (
        
            (isRootOrAdmin) ? (
                <>
                
                    <Link to={to} className={linkClass}>
                        <Button className={buttonClassName} {...props}>
                            <i className="material-icons snx-icon-link md-18" >{editIcon}</i>
                        </Button>
                    </Link>

                </>

            ) : (
                
                <></>
            )
        
    )
}

ButtonEdit.contextTypes = {
    t: PropTypes.func
}

